import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import { convertWeeklySummary } from './shared/convert'
import keys from './shared/keys'
import * as Response from './shared/response'
import { WeeklySummaryData } from './shared/types'

export function useWeeklySummary(
  isHelperWeeklySummary?: boolean,
  storeId?: string
) {
  const { server } = useServer()

  return useQuery<WeeklySummaryData | undefined>({
    queryKey: isHelperWeeklySummary ? keys.helper() : keys.store(storeId!),
    queryFn: fetchWeeklySummary,
  })

  async function fetchWeeklySummary() {
    if (!isHelperWeeklySummary && !storeId) {
      throw new Error('Store not found.')
    }

    try {
      const response = await server.get<Response.WeeklySummary>(
        getUrl(isHelperWeeklySummary, storeId)
      )
      return convertWeeklySummary(response)
    } catch (err: any) {
      throw err
    }
  }
}

function getUrl(isHelperWeeklySummary?: boolean, storeId?: string): string {
  if (isHelperWeeklySummary) {
    return '/v2/users/me/shift_summary'
  } else if (storeId) {
    return `/v2/managers/me/stores/${storeId}/summary`
  } else {
    throw new Error('Store not found.')
  }
}
